import { render, staticRenderFns } from "./ImageTextExplain.vue?vue&type=template&id=3dfae6a3&scoped=true&lang=pug&"
import script from "./ImageTextExplain.vue?vue&type=script&lang=ts&"
export * from "./ImageTextExplain.vue?vue&type=script&lang=ts&"
import style0 from "./ImageTextExplain.vue?vue&type=style&index=0&id=3dfae6a3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfae6a3",
  null
  
)

export default component.exports